import styles from "./resetpasswordblock3.module.css";
import InputNewPass from "../InputNewPass";
import InputConfirmNewPass from "../InputConfirmNewPass";
import ConfirmPassButton from "../ConfirmPassButton";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassVerify } from "../../apis/resetPass";

export default function ResetPasswordBlock3() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get("token");
  
  const { t } = useTranslation();
  const navigate = useNavigate()

  const [newPassValue, setNewPassValue] = useState("");
  const [confirmPassValue, setConfirmPassValue] = useState("");
  const [validation, setValidation] = useState({
    hasLowercase: false,
    hasUppercase: false,
    hasValidLength: false,
    hasValidChars: false,
    hasPassMatch: false,
  });
  const isEmpty = newPassValue === "";
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  
  function validatePassword(password) {
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasValidLength = password.length >= 8 && password.length <= 12;
    const hasValidChars =
      /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(password);
    const hasPassMatch = newPassValue === confirmPassValue;
    return {
      hasLowercase,
      hasUppercase,
      hasValidLength,
      hasValidChars,
      hasPassMatch,
    };
  }

  useEffect(() => {
    resetPassVerify(token).then(response => {
      if(response.status !== 200) navigate("?s=1")
    })
  }, [])

  useEffect(() => {
    setValidation(validatePassword(newPassValue));
    setIsPasswordValid(
      validation.hasLowercase &&
        validation.hasUppercase &&
        validation.hasValidLength &&
        validation.hasValidChars &&
        validation.hasPassMatch
    );
  }, [newPassValue, confirmPassValue]);

  useEffect(() => {
    setIsPasswordValid(
      validation.hasLowercase &&
        validation.hasUppercase &&
        validation.hasValidLength &&
        validation.hasValidChars &&
        validation.hasPassMatch
    );
  }, [validation]);

  return (
    <div className={styles.resetpassBlock}>
      <h2 className={styles.resetText}>{t("reset_pass")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputNewPass
            newPassValue={newPassValue}
            setNewPassValue={setNewPassValue}
          />
        </div>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputConfirmNewPass
            confirmPassValue={confirmPassValue}
            setConfirmPassValue={setConfirmPassValue}
          />
        </div>
      </div>
      <ul className={styles.conditionList}>
        <li
          className={
            isEmpty
              ? ""
              : validation.hasLowercase
              ? styles.valid
              : styles.invalid
          }
        >
          {t("at_least_one_lowercase_character.")}
        </li>
        <li
          className={
            isEmpty
              ? ""
              : validation.hasUppercase
              ? styles.valid
              : styles.invalid
          }
        >
          {t("at_least_one_uppercase_character.")}
        </li>
        <li
          className={
            isEmpty
              ? ""
              : validation.hasValidLength
              ? styles.valid
              : styles.invalid
          }
        >
          {t("8-12_characters.")}
        </li>
        <li
          className={
            isEmpty
              ? ""
              : validation.hasValidChars
              ? styles.valid
              : styles.invalid
          }
        >
          {t("only_common_letters_numbers_characters")}
        </li>
        <li
          className={
            isEmpty
              ? ""
              : validation.hasPassMatch
              ? styles.valid
              : styles.invalid
          }
        >
          {t("passwords_must_match")}
        </li>
      </ul>
      <div className={`col-12 ${styles.confirmButtonContainer}`}>
        <ConfirmPassButton
          isPasswordValid={isPasswordValid}
          newPassValue={newPassValue}
          confirmPassValue={confirmPassValue}
          token={token}
        />
      </div>
      <p className={styles.tosignupPage}>
        {t("first_time_bhive")} <a href="signup">{t("signup")}</a>
      </p>
    </div>
  );
}
